
const service = function($http, $rootScope) {

  const loadOptions = (callback) => {
    $http({
      method: 'GET',
      url: '/api/admin/product_packaging_description',
    }).then(function success(res) {
      callback(null, res.data);
    }, function error(res) {
      callback(res.data, null);
    });
  };

  return {
    loadOptions: loadOptions,
  };
};

service.$inject = ['$http', '$rootScope'];

tiz.service('ProductPackagingDescriptions', service);
